import {
	AuthResponse,
	LoginCredentials,
	OAuthCredentials,
	OTPCredentials,
	RegisterCredentials,
	User
} from '../types/auth.types';
import apiClient from 'services/axios.interceptor';

export const sendOTP = async (formData: OTPCredentials) => {
	const response = await apiClient.post<boolean>(
		'test-service/auth/send-otp',
		formData,
		{
			auth: false
		}
	);
	return response;
};

export const resendOTP = async (formData: OTPCredentials) => {
	const response = await apiClient.post<boolean>(
		'test-service/auth/resend-otp',
		formData,
		{
			auth: false
		}
	);
	return response;
};

export const isEmailExists = async (email: string) => {
	const response = await apiClient.get<boolean>(
		`test-service/auth/user-exists?email=${email}`,
		{ auth: false }
	);

	return response;
};

export const signUp = async (formData: RegisterCredentials) => {
	const response = await apiClient.post<AuthResponse>(
		'test-service/auth/sign-up',
		formData,
		{ auth: false }
	);
	return response;
};

export const signIn = async (formData: LoginCredentials) => {
	const response = await apiClient.post<AuthResponse>(
		'test-service/auth/sign-in',
		formData,
		{ auth: false }
	);
	return response;
};

export const getCurrentUser = async () => {
	const response = await apiClient.get<User>(`test-service/user`);

	return response;
};

export const loginWithGoogle = async (formData: OAuthCredentials) => {
	const response = await apiClient.get<AuthResponse>(
		`test-service/auth/success?code=${formData.code}&redirectUri=${formData.redirectUri}`,
		{
			auth: false
		}
	);
	return response;
};

export const loginWithMailru = async (formData: OAuthCredentials) => {
	const response = await apiClient.get<AuthResponse>(
		`test-service/auth/mailru/success?code=${formData.code}&redirectUri=${formData.redirectUri}`,
		{
			auth: false
		}
	);

	return response;
};

export const loginWithApple = async (formData: OAuthCredentials) => {
	const response = await apiClient.post<AuthResponse>(
		`test-service/auth/apple/success`,
		formData,
		{
			auth: false
		}
	);

	return response;
};
